import { UserAccountState } from './HomePage';

type Action =
    | {
          type: 'update-user-detail';
          surname: string;
          postcode: string;
      }
    | { type: 'set-searching-for-vehicles' }
    | { type: 'reset-vehicle-search' }
    | { type: 'set-search-vehicles-completed' }
    | { type: 'set-loading'; loading: boolean };

const UserAccountReducer = (
    state: UserAccountState,
    action: Action
): UserAccountState => {
    switch (action.type) {
        case 'update-user-detail':
            //if (
            //    state.userDetails.surname === action.surname &&
            //    state.userDetails.postcode === action.postcode
            //) {
            //    return state;
            //}

            return {
                ...state,
                userDetails: {
                    surname: action.surname,
                    postcode: action.postcode
                },
                searchingForVehicles: true,
                searchCompleted: false
            };
        case 'reset-vehicle-search':
            return {
                ...state,
                searchCompleted: false
            };
        case 'set-search-vehicles-completed':
            return {
                ...state,
                searchCompleted: true,
                searchingForVehicles: false,
                loading: false
            };
        case 'set-searching-for-vehicles':
            return {
                ...state,
                searchingForVehicles: true
            };
        case 'set-loading':
            return {
                ...state,
                loading: action.loading
            };
        default:
            return state;
    }
};

export default UserAccountReducer;
